import styled from 'styled-components'
import { BaseTypography } from '../BaseTypography'
import { PADDING } from 'parkway-web-common'

export const NotFoundWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${PADDING.xl}
`

export const ImgWrapper = styled.div`
  max-width: 7.5rem;
  padding: ${PADDING.md}
`

export const Text = styled(BaseTypography.Text)`
  font-weight: 700;
  font-size: 1.125rem;
`
